import React, {FC} from 'react'

export const TableIcon: FC = () => (
    <svg className='canvas-toolbar__icon' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'>
        <rect x='3' y='4' width='18' height='16' rx='2'/>
        <line x1='3' y1='10' x2='21' y2='10'/>
        <line x1='3' y1='15' x2='21' y2='15'/>
        <line x1='9' y1='10' x2='9' y2='20'/>
        <line x1='15' y1='10' x2='15' y2='20'/>
    </svg>
)
